export default class {
    constructor (
        id
    ) {
        this._authorizationProviderRetainingDocumentEnabled = false
        this._cropAvailable = false
        this._cropEnabled = false
        this._description = ''
        this._externalId = ''
        this._id = id
        this._maxSize = 500000
        this._mimeTypes = ['image/jpeg', 'image/png', 'application/pdf']
        this._name = ''
        this._provider = null
        this._supportedTypes = ['JPG', 'PNG', 'PDF', 'JPEG']
        this._uploadedFileId = ''
    }

    get authorizationProviderRetainingDocumentEnabled () {
        return this._authorizationProviderRetainingDocumentEnabled
    }

    set authorizationProviderRetainingDocumentEnabled (authorizationProviderRetainingDocumentEnabled) {
        this._authorizationProviderRetainingDocumentEnabled = authorizationProviderRetainingDocumentEnabled
    }

    get cropAvailable () {
        return this._cropAvailable
    }

    set cropAvailable (cropAvailable) {
        this._cropAvailable = cropAvailable
    }

    get cropEnabled () {
        return this._cropEnabled
    }

    set cropEnabled (cropEnabled) {
        this._cropEnabled = cropEnabled
    }

    get description () {
        return this._description
    }

    set description (description) {
        this._description = description
    }

    get externalId () {
        return this._externalId
    }

    set externalId (externalId) {
        this._externalId = externalId
    }

    get id () {
        return this._id
    }

    set id (id) {
        this._id = id
    }

    get maxSize () {
        return this._maxSize
    }

    set maxSize (maxSize) {
        this._maxSize = maxSize
    }

    get mimeTypes () {
        return this._mimeTypes
    }

    set mimeTypes (mimeTypes) {
        this._mimeTypes = mimeTypes
    }

    get name () {
        return this._name
    }

    set name (name) {
        this._name = name
    }

    get provider () {
        return this._provider
    }

    set provider (provider) {
        this._provider = provider
    }

    get supportedTypes () {
        return this._supportedTypes
    }

    set supportedTypes (supportedTypes) {
        this._supportedTypes = supportedTypes
    }

    get uploadedFileId () {
        return this._uploadedFileId
    }

    set uploadedFileId (uploadedFileId) {
        this._uploadedFileId = uploadedFileId
    }

    toJSON () {
        return {
            authorizationProviderRetainingDocumentEnabled: this.authorizationProviderRetainingDocumentEnabled,
            cropAvailable: this.cropAvailable,
            cropEnabled: this.cropEnabled,
            description: this.description,
            externalId: this.externalId,
            id: this.id,
            maxSize: this.maxSize,
            mimeTypes: this.mimeTypes,
            name: this.name,
            provider: this.provider,
            supportedTypes: this.supportedTypes,
            uploadedFileId: this.uploadedFileId
        }
    }
}
